/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Card_Feature_ModelsInputs */



/**
* | output |
* | --- |
* | "All public LLMs (OpenAI, Anthropic, Google, Mistral) at provider cost, no markup" |
*
* @param {Gateway_Card_Feature_ModelsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_card_feature_models = /** @type {((inputs?: Gateway_Card_Feature_ModelsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Card_Feature_ModelsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle öffentlichen LLMs (OpenAI, Anthropic, Google, Mistral) zum Anbieterpreis, ohne Aufschlag")
	return /** @type {LocalizedString} */ ("All public LLMs (OpenAI, Anthropic, Google, Mistral) at provider cost, no markup")
});